import axios from 'axios';
import { toast } from 'react-toastify';
import {
  DEPLOYMENT_SETTING_SAVE_DB_EXPORT_REQUEST_BEGIN,
  DEPLOYMENT_SETTING_SAVE_DB_EXPORT_REQUEST_SUCCESS,
  DEPLOYMENT_SETTING_SAVE_DB_EXPORT_REQUEST_FAILURE,
  DEPLOYMENT_SETTING_SAVE_DB_EXPORT_REQUEST_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function saveDbExportRequest(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DEPLOYMENT_SETTING_SAVE_DB_EXPORT_REQUEST_BEGIN,
    });
    console.log('These are the arguments that are being passed in the saveDbExport: ', args);
    const header = builderSurfaceJsonContentHeader(args.projectId, true);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${args.version}/db-export`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: DEPLOYMENT_SETTING_SAVE_DB_EXPORT_REQUEST_SUCCESS,
              data: res.data,
            });
            toast.success('Request Created Please Wait for Exporting Process');
            resolve(res.data);
          } else {
            dispatch({
              type: DEPLOYMENT_SETTING_SAVE_DB_EXPORT_REQUEST_FAILURE,
              data: { error: err },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: DEPLOYMENT_SETTING_SAVE_DB_EXPORT_REQUEST_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissSaveDbExportRequestError() {
  return {
    type: DEPLOYMENT_SETTING_SAVE_DB_EXPORT_REQUEST_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DEPLOYMENT_SETTING_SAVE_DB_EXPORT_REQUEST_BEGIN:
      return {
        ...state,
        saveDbExportRequestPending: true,
        saveDbExportRequestError: null,
      };

    case DEPLOYMENT_SETTING_SAVE_DB_EXPORT_REQUEST_SUCCESS:
      return {
        ...state,
        saveDbExportRequestPending: false,
        saveDbExportRequestError: null,
        DbExportRequestList: action.data,
      };

    case DEPLOYMENT_SETTING_SAVE_DB_EXPORT_REQUEST_FAILURE:
      return {
        ...state,
        saveDbExportRequestPending: false,
        saveDbExportRequestError: action.data.error,
      };

    case DEPLOYMENT_SETTING_SAVE_DB_EXPORT_REQUEST_DISMISS_ERROR:
      return {
        ...state,
        saveDbExportRequestError: null,
      };

    default:
      return state;
  }
}
